import { merchantApi } from '@/config/axios'

/** 商家本店客服 - 会话 */
export const MerchantKeFuConversationApi = {
  getConversationList: () =>
    merchantApi.get({ url: '/merchant-api/promotion/kefu-conversation/list' }),
  getConversation: (id: number) =>
    merchantApi.get({ url: `/merchant-api/promotion/kefu-conversation/get?id=${id}` }),
  updateConversationPinned: (data: any) =>
    merchantApi.put({
      url: '/merchant-api/promotion/kefu-conversation/update-conversation-pinned',
      data
    }),
  deleteConversation: (id: number) =>
    merchantApi.delete({ url: `/merchant-api/promotion/kefu-conversation/delete?id=${id}` })
}

/** 商家本店客服 - 消息 */
export const MerchantKeFuMessageApi = {
  sendKeFuMessage: (data: any) =>
    merchantApi.post({ url: '/merchant-api/promotion/kefu-message/send', data }),
  updateKeFuMessageReadStatus: (conversationId: number) => {
    if (conversationId == null) {
      return Promise.resolve(false)
    }
    return merchantApi.put({
      url: `/merchant-api/promotion/kefu-message/update-read-status?conversationId=${conversationId}`
    })
  },
  getKeFuMessageList: (params: any) => {
    if (params?.conversationId == null) {
      return Promise.resolve([])
    }
    return merchantApi.get({ url: '/merchant-api/promotion/kefu-message/list', params })
  }
}
